import React from "react";
import { Accordion } from "react-bootstrap";
import './SurgirTabsResponsive.scss'


const SurgirTabsResponsive = ({ tab }: any) => {

  return (

    <div className="tabs-responsive">
      
        <Accordion
          data-testid="container-accordion"
          defaultActiveKey="0"
        >
          {tab.map((item: any, index: number) => (
            <Accordion.Item
              data-testid="item-accordion"
              key={item.title}
              eventKey={String(index)}>
              <Accordion.Header data-testid="header-accordion">
                {item.title}
              </Accordion.Header>
              <Accordion.Body>
                {item.body}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
     
    </div>

  );
};

export default SurgirTabsResponsive;
